const texts = {
  ra: {
    action: {
      add_filter: "Добави филтър",
      add: "Добави",
      back: "Назад",
      bulk_actions: "избран е 1 запис |||| %{smart_count} избрани записи",
      cancel: "Отмени",
      clear_array_input: "Премахни списък",
      clear_input_value: "Изчисти полето",
      clone: "Клонирай",
      confirm: "Потвърди",
      create: "Създай",
      create_item: "Създай %{item}",
      delete: "Изтрий",
      edit: "Редактирай",
      export: "Експортирай",
      list: "Списък",
      refresh: "Презареди",
      remove_filter: "Премахни този филтър",
      remove_all_filters: "Премахни този филтър",
      remove: "Премахни",
      save: "Запази",
      search: "Търсене",
      save_current_query: "Запази търсенето",
      select_all: "Избери всички",
      select_row: "Избери ред",
      show: "Детайли",
      sort: "Сортирай",
      undo: "Отмени",
      unselect: "Премахни избраните",
      expand: "Отвори",
      close: "Затвори",
      open_menu: "Отвори меню",
      close_menu: "Затвори меню",
      update: "Обнови",
      move_up: "Премести нагоре",
      move_down: "Премести надолу",
      open: "Отвори",
      select_columns: "Избери колони",
      update_application: "Обнови приложението",
    },
    boolean: {
      null: " ",
      true: "Да",
      false: "Не",
    },
    page: {
      create: "Създай %{name}",
      dashboard: "Табло",
      edit: "%{name} #%{id}",
      error: "Нещо се обърка",
      list: "%{name}",
      loading: "Зареждане",
      not_found: "Не е открито",
      show: "%{name} #%{id}",
      empty: "Няма намерени резултати.",
      invite: "Създай първия",
    },
    input: {
      file: {
        upload_several: "Добавете файлове за качване или кликнете, за да изберете файл.",
        upload_single: "Добавете файл за качване или кликнете, за да го изберете.",
      },
      image: {
        upload_several: "Добавете снимки за качване или кликнете, за да изберете файл.",
        upload_single: "Добавете снимка за качване или кликнете, за да я изберете.",
      },
      references: {
        all_missing: "Не мога да открия референтни данни.",
        many_missing: "Поне една от асоциираните референции вече не е налична.",
        single_missing: "Асоциираната референция вече не е налична.",
      },
      password: {
        toggle_visible: "Скрий парола",
        toggle_hidden: "Покажи парола",
      },
    },
    message: {
      about: "Относно",
      are_you_sure: "Сигурен ли сте?",
      auth_error: "Възникна грешка при удостоверяване.",
      bulk_delete_content:
        "Сигурен ли сте, че искате да изтриете %{name}? |||| Сигурен ли сте, че искате да изтриете %{smart_count} записа?",
      bulk_update_content:
        "Сигурен ли сте, че искате да обновите %{name}? |||| Сигурен ли сте, че искате да обновите %{smart_count} записа?",
      bulk_delete_title: "Изтрий %{name} |||| Изтрий %{smart_count} %{name}",
      bulk_update_title: "Обнови %{name} |||| Обнови %{smart_count} %{name}",
      clear_array_input: "Сигурен ли сте, че искате да изтриете списъка?",
      delete_content: "Сигурен ли сте, че искате да изтриете този запис?",
      delete_title: "Изтрий запис с ID: %{id}",
      details: "Детайли",
      error: "Възникна клиентска греша и вашата заявка не можа да бъде изпълнена.",
      invalid_form: "Формата не е попълнена правилно. Моля проверете за грешки.",
      loading: "Страницата зарежда, моля изчакайте.",
      no: "Не",
      not_found: "Може би сте изписали грешен адрес или сте кликнали на объркан линк.",
      yes: "да",
      unsaved_changes: "Имате незапазени промени. Сигурни ли сте, че искате да продължите?",
    },
    navigation: {
      no_results: "Няма намерени резултати",
      no_more_results: "Страница %{page} е извън възможните граници. Опитайте с предходната страница.",
      page_out_of_boundaries: "Страница %{page} е извън възможните граници",
      page_out_from_end: "Не можете да продължите след последната страница",
      page_out_from_begin: "Не можете да върнете по-назад от страница 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} от %{total}",
      partial_page_range_info: "%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}",
      current_page: "Страница %{page}",
      page: "Отидете на страница %{page}",
      first: "Отидете на страница 1",
      last: "Отидете на последната страница",
      next: "Следваща",
      previous: "Предходна",
      page_rows_per_page: "Редове на страница:",
      skip_nav: "Пропусни",
    },
    sort: {
      sort_by: "Подреди по %{field} %{order}",
      ASC: "възходящ",
      DESC: "низходящ",
    },
    auth: {
      auth_check_error: "Моля, впишете се с потребителско име и парола",
      user_menu: "Профил",
      username: "Потребител",
      password: "Парола",
      sign_in: "Влез",
      sign_in_error: "Грешка в оторизацията, моля опитайте отново",
      logout: "",
    },
    notification: {
      updated: "Записът е редактиран |||| %{smart_count} записи бяха редактирани",
      created: "Записът е създаден",
      deleted: "Записът е изтрит |||| %{smart_count} записи бяха изтрити",
      bad_item: "Невалиден запис",
      item_doesnt_exist: "Записът не съществува",
      http_error: "Грешка в комуникацията със сървъра",
      data_provider_error: "dataProvider грешка. Проверете конзолата за грешки.",
      i18n_error: "Не могат да се заредят преводите за посочения език",
      canceled: "Действието е отменено",
      logged_out: "Вашата сесия е изтекла, моля влезте отново.",
      not_authorized: "Нямате достъп до този ресурс.",
      application_update_available: "Налична е нова версия.",
    },
    validation: {
      required: "Задължително",
      minLength: "Трябва да съдържа поне %{min} символа",
      maxLength: "Трябва да съдържа не повече от %{max} символа",
      minValue: "Трябва да е минимум %{min}",
      maxValue: "Трябва да е %{max} или по-малко",
      number: "Трябва да съдържа число",
      email: "Трябва да съдържа валиден email",
      oneOf: "Трябва да е едно от: %{options}",
      regex: "Трябва да отговаря на формат (regexp): %{pattern}",
      unique: "Трябва да е уникален",
    },
    saved_queries: {
      label: "Запазени заявки",
      query_name: "Име",
      new_label: "Запази търсенето на този филтър",
      new_dialog_title: "Запази търсенето като",
      remove_label: "Изтрий търсене",
      remove_label_with_name: 'Изтрий търсене за "%{name}"',
      remove_dialog_title: "Изтрий търсене",
      remove_message: "Сигурен ли си че искаш да изтриеш запазеното търсене?",
      help: "Филтрирайте списъка и запазете тази заявка за по-късно",
    },
    configurable: {
      customize: "Настрой",
    },
  },
  "ra-tree": {
    new_node: "Нов елемент",
    item_moved: "Елементът беше преместен",
    action: {
      add_child: "Добави вътрешен URL",
      add_root: "Добави основен URL",
    },
  },
};

export default texts;
